module.exports = __webpack_public_path__ + "assets/img/36_569.0b230dfb.jpg";